import { useQuery } from '@tanstack/react-query';

import { GlobalReactQueryOptions } from '../../config';
import { AgeCategory } from '../../../models/AgeCategory';
import {
    fetchLibxProductGroupProducts,
    fetchProductGroupProducts,
    FetchProductGroupProductsApiResponse
} from '../../api/productGroups/fetchProductGroupProducts';
import { UseQueryResult } from '../../api/query-types';
import { browserClient } from '../../react-query';

type UseProductGroupProductsQuery = UseQueryResult<'data', FetchProductGroupProductsApiResponse> & {
    queryKey: Array<any>;
};

type UseProductGroupProductsOptions = {
    readonly fetchFunc?: typeof fetchProductGroupProducts;
    readonly ageCategory?: AgeCategory;
    readonly loanFormat?: string | null;
};

const emptyProductGroupProducts = {
    total: 0,
    products: []
};

const useProductGroupProductsQuery = (
    productGroupId: string,
    { fetchFunc = fetchProductGroupProducts, ageCategory, loanFormat }: UseProductGroupProductsOptions = {}
): UseProductGroupProductsQuery => {
    const params = {
        ageCategory,
        loanFormat
    };
    const queryKey = ['productGroupProducts', productGroupId, params];
    const { data, ...result } = useQuery(queryKey, () => fetchFunc(productGroupId, params), {
        ...GlobalReactQueryOptions,
        staleTime: Infinity
    });

    return {
        ...result,
        data: data ?? emptyProductGroupProducts,
        queryKey
    };
};

export function invalidateProductGroupProducts(productGroupId: string) {
    return browserClient.invalidateQueries(['productGroupProducts', productGroupId]);
}

export const useShopProductGroupProductsQuery = (
    productGroupId: string,
    { fetchFunc = fetchProductGroupProducts, ageCategory, loanFormat }: UseProductGroupProductsOptions = {}
): UseProductGroupProductsQuery => {
    return useProductGroupProductsQuery(productGroupId, { fetchFunc, ageCategory, loanFormat });
};

export const useLibxProductGroupProductsQuery = (
    productGroupId: string,
    { fetchFunc = fetchLibxProductGroupProducts, ageCategory }: UseProductGroupProductsOptions = {}
): UseProductGroupProductsQuery => {
    return useProductGroupProductsQuery(productGroupId, { fetchFunc, ageCategory });
};
